const digitsOf = (value: string | null | undefined) => (value ?? '').replace(/\D/g, '');

/** As 27 UFs, para listas de estado (endereço do equipamento e de cobrança). */
export const BRAZIL_UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO'
] as const;

export type BrazilAddressFields = {
  zipcode: string;
  street: string;
  number: string;
  neighborhood: string;
  additional_details: string;
  state: string;
  city: string;
};

type Errors<T> = Partial<Record<keyof T, string>>;

/** Endereço brasileiro completo (renovação e endereço de cobrança); o complemento é opcional. */
export function validateBrazilAddress(values: BrazilAddressFields): Errors<BrazilAddressFields> {
  const errors: Errors<BrazilAddressFields> = {};
  if (digitsOf(values.zipcode).length !== 8) errors.zipcode = 'Informe um CEP válido.';
  if (!values.street.trim()) errors.street = 'Informe o endereço.';
  if (!values.number.trim()) errors.number = 'Informe o número.';
  if (!values.neighborhood.trim()) errors.neighborhood = 'Informe o bairro.';
  if (!(BRAZIL_UFS as readonly string[]).includes(values.state)) errors.state = 'Selecione o estado.';
  if (!values.city.trim()) errors.city = 'Informe a cidade.';
  return errors;
}
